import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, tap } from 'rxjs';

import { Sequence } from '../scénarisation/models/séquence.model';
import { SequenceService } from '../scénarisation/parcours-sequence.service';
import { SequenceStore } from '../scénarisation/store/sequence.store';

export const séquenceResolver: ResolveFn<Observable<Sequence> | undefined> = (route) => {
  const sequenceService = inject(SequenceService);
  const sequenceStore = inject(SequenceStore);
  const idSequence = route.paramMap.get('idSequence');

  if (!idSequence) {
    return undefined;
  }

  return sequenceService.trouveParId(idSequence).pipe(
    tap((sequence) => {
      sequenceStore.ajouterSequence({ sequence });
      sequenceStore.select({ id: sequence.id });
    }),
  );
};
